export const gridColumns = (itemMinWidth) => `repeat(auto-fill, minmax(${itemMinWidth}, 1fr))`;
